import { React } from 'react';

const Features = ({ featureTitle, description, featureClass }) => {
    return (
        <div className={`row mt-5 align-items-center ${featureClass}`}>
            <div className="col-md-6">
                <h4 className="fw-bold">
                    {featureTitle}
                </h4>
                <p className="text-muted">
                    {description}
                </p>
            </div>
            <div className="col-md-6">
                <svg
                    width="100%"
                    height="200"
                    viewBox="0 0 800 400"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect x="50" y="50" width="700" height="300" fill="#f8f9fa" rx="10" />
                    <circle cx="400" cy="200" r="80" fill="#0d6efd" opacity="0.8" />
                    <path d="M380 160 L420 240" stroke="#0d6efd" strokeWidth="20" />
                    <path d="M420 160 L380 240" stroke="#0d6efd" strokeWidth="20" />
                    <rect x="100" y="100" width="120" height="30" fill="#0d6efd" rx="5" />
                    <rect x="100" y="150" width="180" height="30" fill="#0d6efd" opacity="0.6" rx="5" />
                    <rect x="100" y="200" width="150" height="30" fill="#0d6efd" opacity="0.4" rx="5" />
                    <rect x="580" y="100" width="120" height="30" fill="#0d6efd" rx="5" />
                    <rect x="520" y="150" width="180" height="30" fill="#0d6efd" opacity="0.6" rx="5" />
                    <rect x="550" y="200" width="150" height="30" fill="#0d6efd" opacity="0.4" rx="5" />
                </svg>
            </div>
        </div>
    );
}

export default Features;
